import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import style from './IsvSourceIdField.module.scss';

const IsvSourceIdField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<FullInfoField
			label="isvSourceIdLabel"
			value={restaurantForFullInfo?.vivaWalletIsv?.isvSourceId}
			containerClassName={style.container}
		/>
	);
};

export default IsvSourceIdField;
